import { Box, CircularProgress, Typography } from '@mui/material'
import { themeColors } from '../../app/layout/theme'

interface LoadingSpinnerProps {
  size?: number
  fullHeight?: boolean
  label?: string
}

export const LoadingSpinner = ({ size = 36, fullHeight = false, label }: LoadingSpinnerProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        height: fullHeight ? '300px' : 'auto',
        minHeight: fullHeight ? '200px' : 'auto',
      }}
    >
      <CircularProgress
        size={size}
        thickness={3.5}
        sx={{ color: themeColors.primary }}
      />
      {label && (
        <Typography sx={{ fontSize: '13px', color: themeColors.text.secondary }}>
          {label}
        </Typography>
      )}
    </Box>
  )
}
